import Clock from './clock.svg';

export default Clock;
